export default __webpack_public_path__ + "locales/vi/SendInviteDialog.json?hash=0c536eb22ab680272e1039e9a23a891a";